class CCInfo {
    currency = ""
    number = ""
    cvv = ""
    expMonth = ""
    expYear = ""
    ptype = ""
    zip = ""
    city = ""
    address = ""
    country = ""
    state = ""
    fname = ""
    lname = ""
    phone = ""
    isCustom = false

    paysafeToken = ''
    nuveiToken= ''
    mx_curp = ''

    constructor(data){
        Object.assign(this, data);
    }

    mangledJSON(){
        return {...this};
    }

    get isValid(){
        return this.zip !== "" &&
            this.city !== "" &&
            this.country !== "" &&
            this.state !== "" &&
            this.address !== "" &&
            this.fname !== "" &&
            this.lname !== "";
    }

    getValidationError(){
        if(this.zip === "")
            return "Billing Address: Postal Code is required";
        if(this.city === "")
            return "Billing Address: City is required";
        if(this.country === "")
            return "Billing Address: Country is required";
        if(this.state === "")
            return "Billing Address: State/Province is required";
        if(this.fname === "")
            return "First Name is required";
        if(this.lname === "")
            return "Last Name is required";

        return null;
    }

    set(key, value){
        return new CCInfo({...this, [key]: value});
    }
}


export default CCInfo;